export default "__VITE_ASSET__2f619ef3__"